<!-- 注册页面（深色科技风重设计） -->
<template>
  <div class="register-page">
    <!-- 顶部操作栏 -->
    <div class="register-top">
      <div class="top-back" @click="goBack">
        <i class="el-icon-back" />
        <span>{{ $t('button.fh') }}</span>
      </div>
      <language class="top-lang" />
    </div>

    <!-- 主体 -->
    <div class="register-main">
      <div class="register-card">
        <!-- 左侧：品牌 + 纵向步骤导航 -->
        <div class="card-aside">
          <div class="brand">
            <img class="brand-logo" src="../../assets/logo.png" alt="logo">
            <p class="brand-title">{{ $t('text.registerWelcome') }}</p>
          </div>
          <ul class="wizard">
            <li
              v-for="(step, index) in wizardSteps"
              :key="index"
              class="wizard-item"
              :class="[active === index ? 'is-active' : '', active > index ? 'is-done' : '']"
            >
              <div class="wizard-node">
                <span class="node-circle">
                  <i v-if="active > index" class="el-icon-check" />
                  <b v-else>{{ index + 1 }}</b>
                </span>
                <span
                  v-if="index < wizardSteps.length - 1"
                  class="node-line"
                  :class="{ 'line-done': active > index }"
                />
              </div>
              <div class="wizard-info">
                <span class="wizard-title">{{ step }}</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- 右侧：表单内容 -->
        <div class="card-body">
          <div class="body-head">
            <div class="head-title">
              <span class="head-index">0{{ active + 1 }}</span>
              <h3>{{ wizardSteps[active] }}</h3>
            </div>
            <div class="head-dots">
              <span v-for="n in 3" :key="n" :class="{ on: n - 1 === active }" />
            </div>
          </div>

          <div class="body-content">
            <el-scrollbar style="height:100%">
              <div class="step-scroll">
                <!-- step1 用户信息 -->
                <div v-if="active === 0" key="1" class="step-pane">
                  <el-form
                    ref="step1"
                    :model="formUser"
                    :rules="step1Rule"
                    label-position="right"
                    label-width="120px"
                  >
                    <el-form-item :label="$t('text.yhm')" prop="username">
                      <el-input
                        v-model="formUser.username"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item :label="$t('text.mm')" prop="pwd">
                      <el-input
                        v-model="formUser.pwd"
                        show-password
                      />
                    </el-form-item>
                    <el-form-item :label="$t('text.qrmm')" prop="pwdconfirm">
                      <el-input
                        v-model="formUser.pwdconfirm"
                        show-password
                      />
                    </el-form-item>
                  </el-form>
                  <div class="btn-area">
                    <el-button
                      type="primary"
                      class="btn-next"
                      @click="step1()"
                    >{{ $t('button.xyb') }}</el-button>
                  </div>
                </div>

                <!-- step2 电站信息 -->
                <div v-if="active === 1" key="2" class="step-pane">
                  <el-form
                    ref="step2"
                    :model="formStation"
                    :rules="step2Rule"
                    label-position="right"
                    label-width="180px"
                  >
                    <el-form-item :label="$t('text.zdtp')">
                      <img-upload ref="imgUpload" v-model="formStation.img" :url="require('@/assets/image/station.png')" />
                    </el-form-item>
                    <el-form-item :label="$t('text.dzlx')" prop="orgtype">
                      <el-select
                        v-model="formStation.orgtype"
                        clearable
                        placeholder="请选择电站类型"
                        @change="orgtypeChange"
                      >
                        <el-option
                          v-for="item in orgtype"
                          :key="item.value"
                          :label="$t(item.label)"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('text.zdmc')" prop="orgname">
                      <el-input
                        v-model="formStation.orgname"
                        clearable
                      />
                    </el-form-item>
                    <el-form-item :label="$t('text.stationBelongProvince')" prop="province">
                      <el-select
                        v-model="formStation.province"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="(item,index) in provinceOptions"
                          :key="index"
                          :label="item.key"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('text.stationTimezone')" prop="tzonecode">
                      <el-select
                        v-model="formStation.tzonecode"
                        clearable
                      >
                        <el-option
                          v-for="(item,index) in timeOptions"
                          :key="index"
                          :label="item.key"
                          :value="item.value+''"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="formStation.orgtype !== '2' && formStation.orgtype !== '4'" prop="capacity" label="装机容量【单位:kWp】">
                      <el-input-number v-model="formStation.capacity" :min="1" :step="0.1" controls-position="right" :precision="2" style="margin-top: 0;" />
                    </el-form-item>
                  </el-form>
                  <div class="btn-area">
                    <el-button class="btn-prev" @click="active = 0">{{ $t('button.syb') }}</el-button>
                    <el-button
                      type="primary"
                      class="btn-next"
                      @click="step2()"
                    >{{ $t('button.xyb') }}</el-button>
                  </div>
                </div>

                <!-- step3 设备列表 -->
                <div v-if="active === 2" key="3" class="step-pane">
                  <div class="device-box">
                    <div class="device-box-head">
                      <span class="head-icon">
                        <i class="el-icon-connection" />
                      </span>
                      <div class="head-main">
                        <p class="head-title">{{ $t('text.cjqlb') }}</p>
                        <p class="head-tip">{{ $t('text.collectorListTip') }}</p>
                      </div>
                      <span class="head-count">
                        <i class="el-icon-collection-tag" />
                        {{ deviceCount }}
                      </span>
                    </div>
                    <div class="device-box-body">
                      <div class="collector-input-row">
                        <el-input
                          v-model="collectorInput"
                          :placeholder="$t('msg.qsrsn')"
                          clearable
                          @keyup.enter.native="addCollector"
                        />
                        <el-button type="primary" class="collector-add-btn" @click="addCollector">
                          {{ $t('button.tianjia') }}
                        </el-button>
                      </div>
                      <div v-if="formDeviceList.length" class="collector-list">
                        <span v-for="(sn, index) in formDeviceList" :key="sn" class="collector-chip">
                          <i class="el-icon-connection chip-icon" />
                          <span class="chip-text">{{ sn }}</span>
                          <i class="el-icon-close chip-close" @click="removeCollector(index)" />
                        </span>
                      </div>
                      <div v-else class="collector-empty">
                        <i class="el-icon-information" />
                        <span>{{ $t('text.collectorListTip') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="btn-area">
                    <el-button class="btn-prev" @click="active = 1">{{ $t('button.syb') }}</el-button>
                    <el-button
                      type="primary"
                      class="btn-next"
                      :loading="submitLoading"
                      @click="register"
                    >{{ $t('button.zc') }}</el-button>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@views/Imgupload'
import Language from '../../layout/header/Language.vue'
import { GetAddresses, GetTimeZones } from '@apis/Universal'
import { CreateStationByRegister } from '@apis/Stations'
export default {
  components: {
    ImgUpload,
    Language
  },
  data () {
    const validPwdconfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('placeholder.qzcsr')))
      } else if (value !== this.formUser.pwd) {
        callback(new Error(this.$t('notice.mmbyz')))
      } else {
        callback()
      }
    }
    // 站点名称不允许包含 / 或 \
    const validOrgname = (rule, value, callback) => {
      if (/[/\\]/.test(value || '')) {
        callback(new Error(this.$t('msg.stationNameNoSlash')))
      } else {
        callback()
      }
    }
    return {
      active: 0,
      timeOptions: [],
      orgtype: [
        { label: 'text.zc', value: '0' },
        { label: 'text.cn', value: '1' },
        { label: 'text.qx', value: '2' },
        { label: 'text.db', value: '3' },
        { label: 'text.orgtype_switch', value: '4' }
      ],
      provinceOptions: [],
      // 步骤1：账号信息
      formUser: {
        username: '',
        pwd: '',
        pwdconfirm: ''
      },
      // 步骤2：电站信息
      formStation: {
        img: '',
        orgtype: '',
        orgname: '',
        capacity: 1,
        province: '',
        tzonecode: '101'
      },
      // 步骤3：设备列表（采集器SN）
      formDeviceList: [],
      // 第3步：采集器编号输入框
      collectorInput: '',
      step1Rule: {
        username: [
          { required: true, message: this.$t('msg.sryhm'), trigger: 'blur' },
          { min: 2, message: this.$t('msg.zslwyhm'), trigger: 'blur' },
        ],
        pwd: [
          { required: true, message: this.$t('msg.srmm'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('msg.qsrmm'), trigger: 'blur' },
        ],
        pwdconfirm: [
          { required: true, message: this.$t('msg.qzcsrmm') },
          { validator: validPwdconfirm, trigger: 'blur' }
        ],
      },
      step2Rule: {
        orgtype: [
          { required: true, message: this.$t('msg.xzdzlx'), trigger: 'change' }
        ],
        orgname: [
          { required: true, message: this.$t('msg.qsrzdmc'), trigger: 'blur' },
          { validator: validOrgname, trigger: 'blur' }
        ],
        province: [
          { required: true, message: this.$t('msg.qsrsf'), trigger: 'change' }
        ],
        tzonecode: [
          { required: true, message: this.$t('msg.qsrsq'), trigger: 'change' }
        ]
      },

      // 提交loading
      submitLoading: false,
    }
  },
  computed: {
    // 三个步骤标题（跟随语言切换）
    wizardSteps () {
      return [
        this.$t('text.yhxx'),
        this.$t('text.zdxx'),
        this.$t('text.deviceList')
      ]
    },
    // 已添加设备数量
    deviceCount () {
      return this.formDeviceList.length
    }
  },
  created () {
    this.getProvinceOptionsAndTimeZoneOptions()
  },
  methods: {
    // 回退
    goBack () {
      this.$router.go(-1)
    },
    // 第一步 下一步按钮
    step1 () {
      this.$refs.step1.validate((valid) => {
        if (valid) {
          this.active = 1
        }
      })
    },
    // 第二步 下一步按钮
    step2 () {
      this.$refs.step2.validate((valid) => {
        if (valid) {
          this.active = 2
        }
      })
    },
    /** 获取省份和时区选项 */
    getProvinceOptionsAndTimeZoneOptions () {
      Promise.all([
        GetTimeZones({ id: '' }),
        GetAddresses({ id: '44' })
      ]).then(res => {
        this.timeOptions = { ...res[0].data }
        this.provinceOptions = res[1].data
      })
    },
    /** 电站类型切换 */
    orgtypeChange () {
      this.formDeviceList = []
    },
    // 第3步：添加采集器编号
    addCollector () {
      const sn = (this.collectorInput || '').trim()
      if (!sn) {
        this.$msgError(this.$t('msg.qsrsn'))
        return
      }
      if (this.formDeviceList.includes(sn)) {
        this.$msgError(this.$t('notice.bycfsr'))
        return
      }
      this.formDeviceList.push(sn)
      this.collectorInput = ''
    },
    // 第3步：移除采集器编号
    removeCollector (index) {
      this.formDeviceList.splice(index, 1)
    },
    // 第3步：设备列表校验
    validateDeviceList () {
      if (!Array.isArray(this.formDeviceList) || this.formDeviceList.length === 0) {
        this.$msgError(this.$t('msg.qsrsn'))
        return false
      }
      return true
    },
    // 组装提交参数（保持原有接口格式）
    getPostData () {
      const user = {
        userName: this.formUser.username,
        password: this.formUser.pwd,
        passwordConfirm: this.formUser.pwdconfirm,
      }
      const station = {
        image: this.formStation.img,
        stationType: this.formStation.orgtype,
        stationName: this.formStation.orgname,
        stationProvinceCode: this.formStation.province,
        stationTimezoneCode: this.formStation.tzonecode,
        installedCapacity: this.formStation.capacity,
      }
      if (station.image.indexOf('base64') === -1) {
        station.image = null
      }
      return {
        user,
        station,
        gatewaySnList: this.formDeviceList
      }
    },
    // 注册
    register () {
      if (!this.validateDeviceList()) {
        return
      }
      const postData = this.getPostData()
      this.submitLoading = true
      CreateStationByRegister(postData).then(() => {
        this.submitLoading = false
      }).then(() => {
        this.$confirm('电站添加成功,是否直接登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          const loginForm = {
            username: this.formUser.username,
            password: this.formUser.pwd,
            rememberMe: false,
          }
          this.$store.dispatch('user/login', loginForm)
            .then(() => {
              this.$router.push({ path: '/home' })
            })
            .catch(() => {})
        })
      }).catch(() => {
        this.$msgError(this.$t('notice.zcjs'))
        this.submitLoading = false
      })
    }
  }
}
</script>
<style scoped>
@import './style.css';
</style>
